import { TenantRegistrationInfo } from 'graphql/generated/graphqlTypes';
import { tenantRegistrationInfoVar } from 'state/vars';

export const setTenantRegistrationInfoAction = (tenantRegistrationInfo: TenantRegistrationInfo) => {
  tenantRegistrationInfoVar(tenantRegistrationInfo);
};
